import MuiButton from "./../components/basicComponent/MuiButton";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import React, { useState } from "react";
import { FaTrash } from "react-icons/fa"; // Using react-icons for delete icon

interface BankDetails {
  beneficiaryName: string;
  bankName: string;
  accountNumber: string;
  swiftCode: string;
  currency: string;
  bankAddress: string;
  iban: string;
}

const AddBankDetails = () => {
  const [active, setActive] = useState<Boolean>(false);
  const [banks, setBanks] = useState<BankDetails[]>([
    {
      beneficiaryName: "Test",
      bankName: "SBI",
      accountNumber: "87654345678",
      swiftCode: "7654",
      currency: "INR",
      bankAddress: "UAE",
      iban: "98765",
    },
  ]);

  const handleDelete = (index: number) => {
    const newBanks = banks.filter((_, i) => i !== index);
    setBanks(newBanks);
  };
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 managebookingg">
              <h3 className="card-title titlecolorr">
                {active ? "View Bank Details " : "Add Bank Details"}
              </h3>
              <div>
                <button
                  className="fliter-btn me-2"
                  onClick={() => {
                    setActive(!active);
                  }}
                >
                  {active ? "View  Details" : " Add  Details "}
                </button>
              </div>
            </div>
            <div className="card">
              {active && (
                <div className="row">
                  <div className="card-body">
                    <div className="col-md-12">
                      <div className="row mt-3">
                        <div className="col-md-4 mb-3">
                          <MuiInput
                            label={"Beneficiary name "}
                            placeholder="Beneficiary name "
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <MuiInput
                            label={"Bank Name  "}
                            placeholder="Bank Name  "
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <MuiInput
                            label={"Account Number "}
                            placeholder="Account Number"
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <MuiInput
                            label={"Currency"}
                            placeholder="Currency "
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <MuiInput
                            label={"Beneficiary name "}
                            placeholder="Bank Address"
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <MuiInput
                            label={"Beneficiary name "}
                            placeholder="Beneficiary name "
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <MuiInput label={"IBAN"} placeholder="IBAN" />
                        </div>
                        <div className="col-md-4 mb-3">
                          <MuiSearchSelect
                            label="Branch"
                            placeholder={"Branch"}
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                      </div>

                      <div className="user-button w-full">
                        <MuiButton className="clear-btn" label="Clear" />
                        <MuiButton
                          className="get-btn"
                          label="Add details"
                          onClick={() => {}}
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {!active && (
                <>
                <div className="card-body">
                  <div className="row">
                    
                      <div className="col-md-4 mb-3">
                        <MuiInput
                          label={"Branch"}
                          placeholder="Branch"
                        />
                      </div>

                        <div className="user-button w-full">  
                        <MuiButton
                          className="get-btn"
                          label="Get"
                          onClick={() => {}}
                          type="submit"
                        />
                      </div>
                    </div>
                 
                  <div className="row">
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>Beneficiary Name</th>
                            <th>Bank Name</th>
                            <th>Account Number</th>
                            <th>SWIFT Code</th>
                            <th>Currency</th>
                            <th>Bank Address</th>
                            <th>IBAN</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {banks.length > 0 ? (
                            banks.map((bank, index) => (
                              <tr key={index}>
                                <td>{bank.beneficiaryName}</td>
                                <td>{bank.bankName}</td>
                                <td>{bank.accountNumber}</td>
                                <td>{bank.swiftCode}</td>
                                <td>{bank.currency}</td>
                                <td>{bank.bankAddress}</td>
                                <td>{bank.iban}</td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-link text-danger p-0"
                                    onClick={() => handleDelete(index)}
                                  >
                                    <FaTrash />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={8} className="text-center">
                                No Data Available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-end mt-2">
                      <small>
                        {banks.length}–{banks.length} of {banks.length}
                      </small>
                    </div>
                  </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddBankDetails;
